import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import { ReactComponent as IconDocument } from "../../../../images/iconFile.svg";

import "../styles.css";
import AccordionSummaryTitle from "../AccordionSummaryTitle";
import PainelDadosGerais from "../ExameNeurologico/Paineis/PainelDadosGerais";

const handleProgressForm = (data) => {
  const fieldHide = "*";
  const fields = [
    data.frequenciaCardiaca,
    data.pressaoArterial,
    data.pesoAtual === "000000" ? "" : data.pesoAtual,
    // data.perdaDePeso,
    data.fluenciaVerbal,
    data.rastreioComportamental,
    data.apatia,
    data.statusCognitivo,
    data.capacidadeVitalForcada,
    data.pressaoInspiratoria,
    data.pressaoExpiratoria,
    data.pressaoNasalInspiratoria,
  ];

  if (fields.every((campo) => campo !== "")) {
    return "full";
  } else if (fields.some((campo) => campo !== "" && campo !== fieldHide)) {
    return "partial";
  } else {
    return "empty";
  }
};

export default function AnamneseGeral({
  expanded,
  handleChangePanel,
  onSubmit,
  setData,
  data,
  pesoHabitual,
  simOuNaoOptions,
  statusCognitivoOptions,
  ...props
}) {
  const progressForm = handleProgressForm(data);
  return (
    <Accordion
      defaultExpanded={false}
      expanded={expanded === "anamneseGeral"}
      onChange={handleChangePanel("anamneseGeral")}
      className="AccordionContainer"
    >
      <AccordionSummary
        expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
        aria-controls="anamneseGeral-content"
        id="anamneseGeral-header"
        className="AccordionSummaryContainer"
      >
        <AccordionSummaryTitle
          title="Anamnese Geral"
          icon={<IconDocument style={{ width: "24px" }} />}
          progressForm={progressForm}
        />
      </AccordionSummary>
      <AccordionDetails>
        <PainelDadosGerais
          onSubmit={onSubmit}
          data={data}
          setData={setData}
          pesoHabitual={pesoHabitual}
          simOuNaoOptions={simOuNaoOptions}
          statusCognitivoOptions={statusCognitivoOptions}
        />
      </AccordionDetails>
    </Accordion>
  );
}
